(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('DripSettings', [
			'globalConfig',
			'SettingsFactory',
			'urlFactory',
			DripSettingsFunction
		]);

	function DripSettingsFunction(
		globalConfig,
		SettingsFactory,
		urlFactory
	) {
		var dripSettings = this;
		
		dripSettings.submit = function() {
			dripSettings.formSubmitted = true;

			SettingsFactory.dripPreference.set(dripSettings.riaDripSettingsForm, dripSettings.reinvestmentPreference)
				.then(function() {
					urlFactory.submitFormById('riaDripSettingsForm');
				})
				.catch(function() {
					dripSettings.closeInvestmentGoalsModal();
				});

		};
		
		dripSettings.checkInvestmentGoalsState = function() {
			if (dripSettings.riaDripSettingsForm.$valid) {
				if (dripSettings.reinvestmentPreference === 'CASH_DISTRIBUTION' && dripSettings.hasFutureEarningsGoal) {
					dripSettings.activeModal = 'investment-goal-warning';
				} else {
					dripSettings.submit();
				}
			}
		};

		dripSettings.closeInvestmentGoalsModal = function() {
			dripSettings.activeModal = '';
			dripSettings.formSubmitted = false;
		};

		dripSettings.$onInit = function() {
			dripSettings.acceptsDripTerms = false;
			angular.merge(dripSettings, globalConfig);

			SettingsFactory.dripPreference.get()
				.then(function(reinvestmentPreference) {
					dripSettings.reinvestmentPreference = reinvestmentPreference;
				});
		};
	}
})(window.angular);